// extracted by mini-css-extract-plugin
export var messageSideLeft = "_l7-1";
export var messageSideRight = "_l7-2";
export var orderLookupBubbleContainer = "_l7-0";
export var submitButton = "_l7-3";